import React, { useEffect, useState } from 'react'
import { Modal, Box, IconButton, Fade, Backdrop } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import CloseIcon from '@mui/icons-material/Close'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    bgcolor: 'rgba(0, 0, 0, 0.9)',
    border: 'none',
    boxShadow: 24,
    p: 0,
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

const imageStyle = {
    maxWidth: '90%',
    maxHeight: '90%',
    objectFit: 'contain',
    userSelect: 'none',
}

const navButtonStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    zIndex: 1,
}

const closeButtonStyle = {
    position: 'absolute',
    top: 20,
    right: 20,
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    zIndex: 1,
}

export const Lightbox = ({ open, onClose, images = [], initialIndex = 0 }) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex)

    useEffect(() => {
        if (open) {
            setCurrentIndex(initialIndex)
        }
    }, [open, initialIndex])

    const handleNext = (e) => {
        e?.stopPropagation()
        setCurrentIndex((prev) => (prev + 1) % images.length)
    }

    const handlePrev = (e) => {
        e?.stopPropagation()
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length)
    }

    const handleKeyDown = (e) => {
        if (e.key === 'ArrowRight') {
            handleNext()
        } else if (e.key === 'ArrowLeft') {
            handlePrev()
        } else if (e.key === 'Escape') {
            onClose()
        }
    }

    if (!images || images.length === 0) return null

    return (
        <Modal
            open={open}
            onClose={onClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
            onKeyDown={handleKeyDown}
        >
            <Fade in={open}>
                <Box sx={style} onClick={onClose}>
                    {/* Close Button */}
                    <IconButton
                        onClick={onClose}
                        sx={closeButtonStyle}
                        size="large"
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* Previous Button */}
                    {images.length > 1 && (
                        <IconButton
                            onClick={handlePrev}
                            sx={{ ...navButtonStyle, left: 20 }}
                            size="large"
                        >
                            <ArrowBackIosNewIcon />
                        </IconButton>
                    )}

                    {/* Image */}
                    <img
                        src={images[currentIndex]}
                        alt={`Full screen view ${currentIndex + 1}`}
                        style={imageStyle}
                        onClick={(e) => e.stopPropagation()}
                    />

                    {/* Next Button */}
                    {images.length > 1 && (
                        <IconButton
                            onClick={handleNext}
                            sx={{ ...navButtonStyle, right: 20 }}
                            size="large"
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                    )}
                </Box>
            </Fade>
        </Modal>
    )
}
